import React, { useCallback, useEffect, useState } from 'react';
import { Spin, message } from 'antd';
import api from '../../../services/api';
import { getActiveTeamId } from '../../../utils/activeTeam';
import FinanceOnboarding from './FinanceOnboarding';
import FinanceDashboard from './FinanceDashboard';

export default function CommunityFinancePage() {
  const [teamId, setTeamId] = useState(getActiveTeamId());
  const [teamName, setTeamName] = useState('');
  const [access, setAccess] = useState(null); // null=loading; {allowed, reason, activated}
  const [activating, setActivating] = useState(false);

  // Reagir a troca de time via TeamSwitcher
  useEffect(() => {
    const onChange = () => setTeamId(getActiveTeamId());
    window.addEventListener('active_team_changed', onChange);
    return () => window.removeEventListener('active_team_changed', onChange);
  }, []);

  // Buscar nome do time
  useEffect(() => {
    if (!teamId) return;
    api.get('/community/team-owner/my').then(r => {
      const t = (r.data.teams || []).find(x => x.id === teamId);
      if (t) setTeamName(t.name);
    }).catch(() => {});
  }, [teamId]);

  const loadAccess = useCallback(async () => {
    if (!teamId) return;
    try {
      const r = await api.get('/community/finance/access-check', { params: { team_id: teamId } });
      setAccess(r.data);
    } catch (e) {
      message.error('Falhou verificar acesso ao Financeiro');
      setAccess({ allowed: false, reason: 'error', activated: false });
    }
  }, [teamId]);

  useEffect(() => { loadAccess(); }, [loadAccess]);

  const activate = async () => {
    setActivating(true);
    try {
      await api.post('/community/finance/activate', { community_team_id: teamId });
      message.success('Financeiro ativado pro time!');
      await loadAccess();
    } catch (e) {
      const reason = e.response?.data?.reason;
      if (reason === 'not_in_beta') {
        message.warning('Seu time ainda não tem acesso ao Financeiro (beta)');
        setAccess(prev => ({ ...prev, allowed: false, reason: 'not_in_beta' }));
      } else {
        message.error(e.response?.data?.message || 'Falhou ativar');
      }
    } finally { setActivating(false); }
  };

  if (!teamId) {
    return <div style={{ padding: 32, textAlign: 'center' }}>Escolha um time no seletor pra abrir o Financeiro.</div>;
  }
  if (!access) {
    return <div style={{ padding: 32, textAlign: 'center' }}><Spin /></div>;
  }

  if (access.activated) {
    return <FinanceDashboard teamName={teamName || 'Meu Time'} communityTeamId={teamId} />;
  }

  return (
    <FinanceOnboarding
      teamName={teamName || 'Meu Time'}
      onActivate={activate}
      activating={activating}
      notInBeta={!access.allowed && access.reason === 'not_in_beta'}
    />
  );
}
